import { Divider, Typography, Button, IconButton } from '@mui/material';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { Link } from 'react-router-dom';

import Grid from '@mui/material/Grid2';
import React, { useState } from 'react';
import { useAdminsPageOptions } from '../../hooks/useAdminsPageOptions';
import { useHistory } from 'react-router-dom';
import { useStyles } from './styles';
import Collapse from '@mui/material/Collapse';

const GridItem = ({ label, description, icon: Icon, route }) => {
  const classes = useStyles();
  const history = useHistory();

  return (
    <Grid
      item="true"
      className={classes.item}
      size={{ md: 6, sm: 12 }}
      onClick={() => history.push(route)}
      data-text="card"
    >
      <Grid container spacing={2}>
        <Grid item="true">
          <Icon className={classes.icon} />
        </Grid>
        <Grid item="true" size={10}>
          <Typography variant="h6">{label}</Typography>
          <Divider />
          <Typography variant="caption">{description}</Typography>
        </Grid>
      </Grid>
    </Grid>
  );
};

const SubmenuCard = ({ label, description, icon: Icon, children }) => {
  const classes = useStyles();
  const [expanded, setExpanded] = useState(false);

  const handleExpandClick = (e) => {
    e.stopPropagation(); // Prevent card click from triggering
    setExpanded(!expanded);
  };

  return (
    <Grid
      item="true"
      className={`${classes.item} ${expanded ? classes.expandedItem : ''}`}
      size={{ md: 6, sm: 12 }}
    >
      <Grid container spacing={2}>
        <Grid item="true">
          <Icon className={classes.icon} />
        </Grid>
        <Grid item="true" size={10}>
          <div className={classes.submenuHeader}>
            <Typography variant="h6">{label}</Typography>
            <IconButton
              size="small"
              onClick={handleExpandClick}
              className={classes.expandButton}
              color={expanded ? "primary" : "default"}
            >
              {expanded ? <ExpandLess /> : <ExpandMore />}
            </IconButton>
          </div>
          <Divider />
          <Typography variant="caption">{description}</Typography>

          <Collapse in={expanded} timeout="auto" unmountOnExit>
            <div className={classes.submenuContainer}>
              {children.map((child) =>
                child.hide ? null : (
                  <Button
                    key={child.label}
                    variant="outlined"
                    color="primary"
                    startIcon={<child.icon />}
                    className={classes.submenuButton}
                    component={Link}
                    to={child.route}
                    fullWidth
                    sx={{ mt: 1 }}
                  >
                    {child.label}
                  </Button>
                )
              )}
            </div>
          </Collapse>
        </Grid>
      </Grid>
    </Grid>
  );
};

export const AdminsPage = () => {
  const classes = useStyles();
  const adminsPageOptions = useAdminsPageOptions();

  return (
    <div className={classes.root}>
      <div className={classes.scroll}>
        <Grid container spacing={2} className={classes.landingPageContainer}>
          <Grid size={12}>
            <Typography variant="h4" className={classes.header}>
              Admins Portal
            </Typography>
            <Divider />
          </Grid>
          {adminsPageOptions.map((option) => {
            if (option.hide) return null;

            if (option.isSubmenu) {
              return <SubmenuCard key={option.label} {...option} />;
            }

            return <GridItem key={option.label} {...option} />;
          })}
        </Grid>
      </div>
    </div>
  );
};
